import { useMemo } from "react";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const pad = (n) => String(n).padStart(2, "0");

export function TimeInput({ value, onChange, className = "", disabled, "data-testid": testid }) {
  const [h, m] = (value || "").split(":").map(Number);
  const has = !!value && !Number.isNaN(h);
  const ap = has ? (h >= 12 ? "PM" : "AM") : "";
  const h12 = has ? h % 12 || 12 : "";
  const mins = useMemo(() => { const base = Array.from({ length: 12 }, (_, i) => i * 5); return has && !base.includes(m) ? [...base, m].sort((a, b) => a - b) : base; }, [has, m]);
  const emit = (nh, nm, nap) => onChange({ target: { value: nh === "" ? "" : `${pad((Number(nh) % 12) + (nap === "PM" ? 12 : 0))}:${pad(nm || 0)}` } });
  const sel = "bg-transparent outline-none appearance-none cursor-pointer disabled:cursor-default num";
  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid={testid} role="group" aria-label="Time">
      <select className={sel} disabled={disabled} value={h12} onChange={(e) => emit(e.target.value, has ? m : 0, ap || "PM")} aria-label="Hour" data-testid={testid && `${testid}-hour`}>
        <option value="">--</option>{HOURS.map((x) => <option key={x} value={x}>{x}</option>)}</select>
      <span className="text-stone-400">:</span>
      <select className={sel} disabled={disabled || !has} value={has ? m : ""} onChange={(e) => emit(h12, Number(e.target.value), ap)} aria-label="Minute" data-testid={testid && `${testid}-minute`}>
        {!has && <option value="">--</option>}{mins.map((x) => <option key={x} value={x}>{pad(x)}</option>)}</select>
      <select className={`${sel} ml-1`} disabled={disabled || !has} value={ap} onChange={(e) => emit(h12, m, e.target.value)} aria-label="AM or PM" data-testid={testid && `${testid}-ampm`}>
        {!has && <option value="">--</option>}<option value="AM">AM</option><option value="PM">PM</option></select>
    </div>
  );
}
